import {
    CircularProgress, TableContainer, Table, TableHead, TableBody, Paper, TablePagination,
    Button, TextField, DialogActions, Dialog, DialogContent, DialogTitle
} from '@mui/material';
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import React, { useEffect, useState } from 'react';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#19438C',
        color: 'white',
        fontSize: 16,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        borderRight: 'none',
        borderLeft: 'none',
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    '&:last-child td, &:last-child th': {
        border: 0,
    },
    '&:hover': {
        backgroundColor: '#C1C1C1',
    },
}));

function ContratosPendientes() {
    const [page, setPage] = useState(0);
    const [loading, setLoading] = useState(true);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [filas, setFilas] = useState([]);
    const [openDialog, setOpenDialog] = useState(false);
    const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [motivoCancelacion, setMotivoCancelacion] = useState('');

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await fetch("https://be.injupemp.gob.hn:8443/api/contrato/Pendientes/");
                //const response = await fetch("http://172.20.7.10:8082/api/contrato/Pendientes/");
                const data = await response.json();
                setFilas(data);
            } catch (error) {
                console.error('Error al obtener datos:', error);
            } finally {
                setLoading(false);
            }
        }
        fetchData();
    }, []);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleOpenDialog = (row) => {
        setSelectedRow(row);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setSelectedRow(null);
        setMotivoCancelacion('');
    };

    const handleCancelarSolicitud = () => {
        if (motivoCancelacion.trim() === '') {
            alert('Por favor, ingrese el motivo de la cancelación.');
            return;
        }
        setOpenConfirmationDialog(true);
    };

    const handleConfirmarCancelacion = async () => {
        setOpenConfirmationDialog(false);
        const formData = new FormData();
        formData.append('codigoID', selectedRow.CodigoID);
        formData.append('estado', 'Cancelado');
        formData.append('observacion', motivoCancelacion);

        try {
            const response = await fetch("https://be.injupemp.gob.hn:8443/api/contrato/Actualizar/", {
                method: 'PATCH',  // Cambio de POST a PATCH
                body: formData,
            });

            if (response.ok) {
                alert('Solicitud cancelada exitosamente.');
                handleCloseDialog();
                // Aquí podrías actualizar la lista de contratos pendientes si es necesario
            } else {
                alert('Error al cancelar la solicitud.');
            }
        } catch (error) {
            console.error('Error al enviar datos:', error);
            alert('Error al cancelar la solicitud.');
        }
    };


    return (
        <div className="container" style={{ marginTop: 10 }}>
            {loading ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
                    <CircularProgress />
                </div>
            ) : (
                <>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 10 }}>
                        <h2><b>Contratos Pendientes Para Creación de Usuarios de INJUPEMP Conectados</b></h2>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <h2>Total de Pendientes: {filas.length}</h2>
                    </div>

                    <TableContainer component={Paper} style={{ marginTop: '20px' }}>
                        <Table>
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell>#</StyledTableCell>
                                    <StyledTableCell>Nombre Completo</StyledTableCell>
                                    <StyledTableCell>DNI</StyledTableCell>
                                    <StyledTableCell>Correo</StyledTableCell>
                                    <StyledTableCell>Fecha</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>Acciones</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {filas.length > 0 ? (
                                    filas.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                                        <StyledTableRow key={row.CodigoID}>
                                            <StyledTableCell>{index + 1 + page * rowsPerPage}</StyledTableCell>
                                            <StyledTableCell>{row.NombreCompleto}</StyledTableCell>
                                            <StyledTableCell>{row.DNI}</StyledTableCell>
                                            <StyledTableCell>{row.Correo}</StyledTableCell>
                                            <StyledTableCell>
                                                {new Date(row.FechaAceptacion).toLocaleString('es-ES', {
                                                    day: '2-digit',
                                                    month: '2-digit',
                                                    year: 'numeric',
                                                    hour: '2-digit',
                                                    minute: '2-digit',
                                                    second: '2-digit',
                                                    hour12: false
                                                })}
                                            </StyledTableCell>                                            <StyledTableCell
                                                style={{
                                                    textAlign: 'center',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}
                                            >
                                                <Button
                                                    onClick={() => handleOpenDialog(row)}
                                                    variant="contained"
                                                    color="primary"
                                                    style={{
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        width: '190px',
                                                    }}
                                                >
                                                    Cancelar Solicitud
                                                </Button>
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    ))
                                ) : (
                                    <StyledTableRow>
                                        <StyledTableCell colSpan={6} style={{ textAlign: 'center' }}>
                                            No se encontraron datos
                                        </StyledTableCell>
                                    </StyledTableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {filas.length > 0 && (
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25]}
                            component="div"
                            count={filas.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            labelRowsPerPage={"Filas por página"}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    )}
                    <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth>
                        <DialogTitle style={{ textAlign: 'center' }}>Cancelar Solicitud de Creación de Usuario</DialogTitle>
                        <DialogContent style={{ minHeight: '100px' }}>
                            {selectedRow && (
                                <div>
                                    <p><strong>Nombre:</strong> {selectedRow.NombreCompleto}</p>
                                    <p><strong>DNI:</strong> {selectedRow.DNI}</p>
                                    <p><strong>Correo:</strong> {selectedRow.Correo}</p>
                                </div>
                            )}
                            <TextField
                                fullWidth
                                multiline
                                rows={5}
                                label="Motivo de la cancelación"
                                variant="outlined"
                                value={motivoCancelacion}
                                onChange={(e) => setMotivoCancelacion(e.target.value)}
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleCloseDialog} color="error">Cerrar</Button>
                            <Button onClick={handleCancelarSolicitud} color="primary" variant="contained">Cancelar Solicitud</Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog open={openConfirmationDialog} onClose={() => setOpenConfirmationDialog(false)}>
                        <DialogTitle style={{ textAlign: 'center' }}>Confirmar Cancelación</DialogTitle>
                        <DialogContent>
                            <p>¿Está seguro de cancelar la solicitud de creación de usuario en INJUPEMP Conectados de "{selectedRow?.NombreCompleto}"?</p>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setOpenConfirmationDialog(false)} color="error">No</Button>
                            <Button onClick={handleConfirmarCancelacion} color="primary" variant="contained">Sí</Button>
                        </DialogActions>
                    </Dialog>
                </>
            )}
        </div>
    );
}

export default ContratosPendientes;